import { render } from "./ProjectsListView.vue?vue&type=template&id=f6515598&scoped=true"
import script from "./ProjectsListView.vue?vue&type=script&lang=js"
export * from "./ProjectsListView.vue?vue&type=script&lang=js"

import "./ProjectsListView.vue?vue&type=style&index=0&id=f6515598&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6515598"]])

export default __exports__